<template>
    <div class="time-line-wrap">
        <div class="time-line-item-wrap" :class="item.flowStatus == 4 ? 'red':'blue'" v-for="item in list" :key="item.id">
            <div class="circle"></div>
            <div class="time-line-item flex">
                <i class="el-icon-user-solid" style="font-size:40px;margin-right:10px"></i>
                <div class="flex-col" style="flex: 1 0 auto;">
                    <div class="flex" style="height:40px;align-items: center;">
                        <span class="time-line-title">{{item.label}}</span>
                        <i class="el-icon-time "></i>
                        <span class="time-line-time">{{item.time }}</span>
                    </div>
                    <div class="time-line-msg">{{item.msg}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: "timeLines",
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
.red{
  &::before {
    box-shadow: 0px 0px 9px 0px rgba(245,108,108, 0.8);
    background: #f56c6c;
  }
  .time-line-item {
    border-color: #f56c6c;
    background:rgba(245,108,108, 0.05);
  }
}
.blue{
  &::before {
    box-shadow: 0px 0px 9px 0px rgb(45, 83, 218, 0.8);
    background: #0c6fff;
  }
  .time-line-item {
    border-color: #0c6fff;
    background:rgba(0, 165, 255, 0.05);
  }
}
.time-line-item-wrap {
  padding-left: 120px;
  position: relative;
  margin-bottom: 20px;

  &::before {
    content: '';
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    position: absolute;
    left: 40px;
    top: 0px;
    z-index: 5;
  }
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    width: 2px;
    height: 120px;
    background: #d6d6d6;
    left: 48px;
    top: 10px;
  }
  .time-line-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: bold;
    color: #333333;
    flex: 1 0 auto;
    align-items: center;
  }
  .time-line-time {
    color: #666666;
    font-size: 14px;
    padding-left: 10px;
  }
  .time-line-msg {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 26px;
  }
  .time-line-item {
    // padding-left: 35px;
    position: relative;
    height: 110px;
    border-width: 1px;
    border-style: solid;
    // border: 1px solid #0c6fff;
    border-radius: 3px;
    padding: hhh(16) www(25);
  }
}
</style>
